import ColorSchema from "../assets/kits/colors";
import "../components/vendorPanel/orders/vendor-order.scss";

import OrderTabs from "../components/vendorPanel/orders/OrderTabs";

export default function VendorOrders() {
  return (
    <div className="vendor-order">
      <div className="title-h3-b mr-t-8 pd-b-16 pd-r-20">سفارش‌گیری</div>
      <div
        style={{
          borderBottom: `1px solid ${ColorSchema.gray_600}`,
          opacity: 0.1,
        }}
      ></div>
      <div className="mr-x-16 mr-t-16">
        {" "}
        <OrderTabs />
      </div>
    </div>
  );
}
